function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.14441 5.87671H8.85728V10.1589H7.14441V5.87671ZM7.14355 11.0153H8.85643V12.7282H7.14355V11.0153Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.51394 0.909534C9.2159 0.348569 8.63524 0 7.99976 0C7.36429 0 6.78363 0.348569 6.48559 0.910391L0.201065 12.7832C0.0616096 13.0439 -0.00746999 13.3365 0.000640063 13.632C0.00875011 13.9276 0.0937695 14.2159 0.247312 14.4686C0.398643 14.7224 0.613558 14.9324 0.870839 15.0778C1.12812 15.2232 1.41887 15.299 1.71439 15.2976H14.2851C14.8915 15.2976 15.4405 14.9876 15.7531 14.4686C15.9064 14.2158 15.9912 13.9275 15.9994 13.632C16.0075 13.3365 15.9385 13.044 15.7993 12.7832L9.51394 0.909534ZM1.71439 13.5848L7.99976 1.71201L14.2894 13.5848H1.71439Z"
});

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7f1b41e3.svg";
export { ForwardRef as ReactComponent };